import React from "react";
import Modal from "./Modal";
import Button from "./Button";
import { Image as ImageIcon } from "lucide-react";

const ImageModal = ({ isOpen, onClose, imageUrl, title = "Evidencia de Consumo" }) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={title}
      size="md"
      footer={
        <Button variant="secondary" onClick={onClose}>
          Cerrar
        </Button>
      }
    >
      <div className="flex justify-center items-center p-4 bg-gray-50 rounded-lg">
        {imageUrl ? (
          <img
            src={imageUrl}
            alt={title}
            className="max-w-full max-h-[60vh] object-contain rounded shadow-sm"
          />
        ) : (
          <div className="text-gray-500 flex flex-col items-center">
            <ImageIcon className="w-12 h-12 mb-2 opacity-50" />
            <p>Imagen no disponible</p>
          </div>
        )}
      </div>
    </Modal>
  );
};

export default ImageModal;
